import React, { useEffect } from 'react'
import Navbar from '../../layout/Navbar'
import Header from '../../layout/Header'
import MainAboutUs from './MainAboutUs'
import Team from './Team'
import Review from '../../layout/Review'
import DownloadSection from '../../layout/downloadSection'
import Footer from '../../layout/Footer'
import SEO, { getSEOData } from '../../components/SEO'
import Schema from '../../components/Schema'

function AboutUs() {
  useEffect(() => {
    // Scroll to top when the pathname changes
    window.scrollTo(0, 0);
  }, []);

  const seo = getSEOData('about');
  return (
    <div className='about'>
      <SEO
        title={seo.title.replace(' | Pulpit', '').replace('Pulpit - ', '')}
        description={seo.description}
        keywords={seo.keywords}
      />
      <Schema type="organization" />
      <Navbar page="about-us"></Navbar>
      <Header></Header>
      <MainAboutUs></MainAboutUs>
      {/* <Team></Team> */}
      <Review></Review>
      <DownloadSection></DownloadSection>
      <Footer></Footer>
    </div>
  )
}

export default AboutUs